


@if (isReady) {
  <div class="graph-errors">
    @if (showNoData === false) {
      <app-graph-mixed [config]="graphConfigObs" class="graph"></app-graph-mixed>
      @if (!!details) {
        <div class="details">
          <mat-toolbar [ngStyle]="details.style">
            {{details.chartColumnLabel  | translate}}
          </mat-toolbar>
          <div class="table-container">
            <table [dataSource]="details.data" mat-table>
              <ng-container matColumnDef="learner">
                <th *cdkHeaderCellDef [ngStyle]="details.style" class="header-cell-learner"
                mat-header-cell> {{'graph_mathia.errors_table_learner' | translate}} </th>
                <td *cdkCellDef="let row" class="cell-learner" mat-cell>
                  {{row.learner}}
                </td>
              </ng-container>
              <ng-container matColumnDef="count">
                <th *cdkHeaderCellDef [ngStyle]="details.style" class="header-cell-average"
                mat-header-cell> {{'graph_mathia.errors_table_count' | translate}} </th>
                <td *cdkCellDef="let row" class="cell-average" mat-cell>
                  {{row.count}}
                </td>
              </ng-container>
              <ng-container matColumnDef="link">
                <th *cdkHeaderCellDef [ngStyle]="details.style" class="header-cell-link"
                mat-header-cell> {{'graph_mathia.errors_table_link' | translate}} </th>
                <td *cdkCellDef="let row" class="cell-link" mat-cell>
                  <button (click)="onTableClick(row.link)">
                    <mat-icon svgIcon="analytics"></mat-icon>
                  </button>
                </td>
              </ng-container>
              <tr *matHeaderRowDef="details.displayedColumns; sticky: true" mat-header-row></tr>
              <tr *matRowDef="let row; columns: details.displayedColumns;" mat-row></tr>
            </table>
          </div>
        </div>
      }
    } @else {
      <div class="no-data-container">
        {{'graph_mathia.no-data-container' | translate}}
      </div>
    }
  </div>
} @else {
  <div class="center spinner-container">
    <app-fake-stepper [options]="loaderOptions"></app-fake-stepper>
  </div>
}
